<template>
  <path
    d="M7 13.0002C8.65 13.0002 10 11.6502 10 10.0002C10 8.35024 8.65 7.00024 7 7.00024C5.35 7.00024 4 8.35024 4 10.0002C4 11.6502 5.35 13.0002 7 13.0002ZM19 7.00024H13C11.9 7.00024 11 7.90024 11 9.00024V14.0002H3V8.00024C3 7.45024 2.55 7.00024 2 7.00024C1.45 7.00024 1 7.45024 1 8.00024V15.0002C1 16.1002 1.9 17.0002 3 17.0002H21C22.1 17.0002 23 16.1002 23 15.0002V11.0002C23 8.79024 21.21 7.00024 19 7.00024Z"
  />
</template>
